export default class FlyOverlay {
    constructor(option) {
        this.option = {
            type: "1",
            ...option
        }

        this.data = [];
        this.top10 = [];
        this.type = this.option.type //1 流出 2 流入
    }
    getLables(bMap) {
        return this.top10.map((row) => {
            let item;
            if (this.type == "1") {
                item = row.to;
            } else {
                item = row.from;
            }
            const coordinates = item.coordinates;
            const point = new BMap.Point(coordinates[0], coordinates[1]);
            const pixel = bMap.pointToPixel(point);
            return {
                ...item,
                value: row.value,
                pixel: {
                    x: pixel.x - 10,
                    y: pixel.y - 10
                }
            }
        });
    }
    setValue(data) {
        data.sort((b, a) => {
            return a.value - b.value;
        });
        this.data = data;
    }
    toString() {
        const top10 = this.data.slice(0, 10);
        const other = this.data.slice(10);
        this.top10 = top10;

        const row1 = top10[0];

        const center = this.type == "1" ? row1.from : row1.to;
        const boldData = [{
            "name": center.name,
            "value": center.coordinates,
            "symbolSize": 10,
        }];

        const {
            fromData,
            toData
        } = this.getFromToData(other);
        const config = [{
                "type": "lines",
                "zlevel": 1,
                "effect": {
                    "show": true,
                    "period": 6,
                    "trailLength": 0.7,
                    "color": "rgba(71, 214, 208, 0.35)",
                    // "symbolSize": [10, 20]
                },
                "lineStyle": {
                    "color": "rgba(52,242,218,0.15)",
                    "width": 2,
                    "shadowBlur": 5,
                    "curveness": 0.1
                },
                "tooltip": {
                    "show": false
                },
                "data": this.getLine(top10, other),
            },
            //加粗字体样式
            {
                "type": "scatter",
                "coordinateSystem": "geo",
                "zlevel": 30,
                "rippleEffect": {
                    // "brushType": "stroke"
                },
                "label": {
                    "show": true,
                    "position": "right",
                    "formatter": "{b}",
                    "fontSize": 15,
                    "color": "#ffffff",
                    "fontWeight": "bold",
                    "padding": [0, 0, 0, 0]
                },
                "itemStyle": {
                    "color": 'rgba(238,45,86,0.8)'
                },
                "data": boldData,

            },
            //普通样式
            {
                "type": "scatter",
                "coordinateSystem": "geo",
                'rippleEffect': {
                    // brushType: 'stroke'
                },
                "zlevel": 2,
                "label": {
                    "show": true,
                    "position": "right",
                    "formatter": "{b}",
                    "unit": "%",
                    "fontSize": 10,
                    "color": "#ffffff",
                },
                "itemStyle": {
                    "color": "rgba(71, 214, 208, 0.8)",
                },
                "data": this.type == '1' ? toData : fromData,
            }

        ];

        return config;
    }
    getFromToData(otherData) {
        const fromData = [],
            toData = [];
        for (let index = 0; index < otherData.length; index++) {
            const item = otherData[index];
            const from = item.from;
            const to = item.to;
            const findFromConfig = fromData.findIndex((item) => {
                return item.name == from.name;
            });

            if (findFromConfig == -1) {
                fromData.push({
                    "name": from.name,
                    "value": from.coordinates,
                    "symbolSize": 1,
                })
            }
            const findToConfig = toData.findIndex((item) => {
                return item.name == to.name;
            });

            if (findToConfig == -1) {
                toData.push({
                    "name": to.name,
                    "value": to.coordinates,
                    "symbolSize": 10,
                })
            }
        }

        return {
            fromData: fromData,
            toData: toData
        };
    }

    getLine(top10, other) {
        return top10.map((item) => {
                return {
                    "fromName": item.from.name,
                    "toName": item.to.name,
                    "coords": [
                        item.from.coordinates,
                        item.to.coordinates
                    ],
                    "value": item.value,
                    "effect": {
                        "show": true,
                        "period": 6,
                        "trailLength": 0.7,
                        "color": "rgba(71, 214, 208, 0.35)",
                        "symbolSize": [4, 8]
                    },
                    "lineStyle": {
                        "color": "rgba(52,242,218,0.15)",
                        "shadowColor": 'rgba(52,242,218,0.15)',
                        "width": 1,
                        "shadowBlur": 5,
                        "curveness": 0.1
                    },
                };
            })
            .concat(
                other.map((item) => {
                    return {
                        "fromName": item.from.name,
                        "toName": item.to.name,
                        "coords": [
                            item.from.coordinates,
                            item.to.coordinates
                        ],
                        "value": item.value,
                        "effect": {
                            "show": true,
                            "period": 6,
                            "trailLength": 0.7,
                            "color": "rgba(71, 214, 208, 0.35)",
                            "symbolSize": [2, 4]
                        },
                        "lineStyle": {
                            "color": "rgba(52,242,218,0.15)",
                            "width": 0.5,
                            "shadowBlur": 5,
                            "curveness": 0.1
                        },
                    }
                })
            );

    }

}